import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Checkbox,
  Alert,
  Tooltip
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { Breadcrumb as BreadcrumbComponent } from "../../../components";
import "../../../style/subAdmin/SubAdmin.scss";
import isEmpty from "lodash.isempty";
import {
  getMerchantDeals,
  getMerchantVoucherList,
  upload_TrackingNumbers,
  getUploadTrackingHistory
} from "../../../redux/actions/voucherActions";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import loader from "../../../style/loader/loader.scss";
import { CSVLink } from "react-csv";
import Pagination from "react-paginating";
import { appConfig } from "../../../config";

const history = createBrowserHistory();
let isLoading = "false",
  dealID = "",
  headers = [],
  data = [],
  userID = "";

class Upload extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      voucherID: "",
      path: ["Home", "Upload Voucher Tracking Number"],
      alertMessage: "",
      show: false,
      disabled: "",
      voucherNumber: "",
      merchantName: "",
      deallist: [],
      dealID: "",
      uploadError: "",
      fileName: "",
      totalRecords: 0,
      limit: 10,
      search: "",
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      voucherData: "",
      firstNameSortIcon: "glyphicon glyphicon-sort-by-attributes-alt",
      uploadList: "",
      csvData: [
                [
                  "Voucher Number",
                  "Tracking Number",
                ],
                [
                  "555555555",
                  "666666666",
                ],
              ]
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.validate = this.validate.bind(this);
    this.Clear = this.Clear.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }

  handlePageChange = page => {
    this.setState({
      currentPage: page
    });

    const postData = {
      page: page,
      limit: this.state.limit
    };

    this.props.getUploadTrackingHistory(postData);
  };

  handleSort = orderBy => e => {
    e.preventDefault();

    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes-alt",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-sort-by-attributes",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    this.props.getUploadTrackingHistory({
      orderBy: orderBy,
      direction: direction
    });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => {
    let isError = false;
    const errors = {};

    if (!this.state.upload) {
      isError = true;
      this.setState({ uploadError: "Please choose file." });
    }
    return isError;
  };

  getValidationState() {
    if (this.state.upload) {
      if (
        !/.*\.xlsx$/.test(file.name) &&
        !/.*\.xls$/.test(file.name) &&
        !/.*\.csv$/.test(file.name)
      ) {
        return "error";
      }
    }
    return null;
  }

  handleSubmit(e) {
    e.preventDefault();
    const err = this.validate();

    if (!err) {
      const formData = new FormData();

      if (this.state.fileName) {
        let file = this.state.fileName;
        formData.append("file", file);
        formData.append("dealID", dealID);
      }

      this.props.upload_TrackingNumbers(formData);
    }
  }
  handleChange(e) {
    this.setState({ qtyMessage: "" });
    if (`${e.target.name}Error` !== "") {
      this.setState({ [`${e.target.name}Error`]: "" });
    }
    this.setState({ [e.target.name]: e.target.value });

    let files = e.target.files[0];
    this.setState({ uploadError: "" });

    if (files.name !== "") {
      if (
        !/.*\.xlsx$/.test(files.name) &&
        !/.*\.xls$/.test(files.name) &&
        !/.*\.csv$/.test(files.name)
      ) {
        this.setState({
          uploadError: "File format should in csv,xls or xlsx only."
        });
      } else {
        const inputFiles = document.querySelectorAll("uploadfile");
        this.setState({ fileName: files });
        this.setState({ uploadError: "" });
      }
    }
    this.setState({ disabled: false });
  }

  componentWillMount() {
    this.handleDismiss();
    this.props.clearAlert();
    dealID = this.props.match.params.dealID
      ? this.props.match.params.dealID
      : "";
    userID = this.props.match.params.userID
      ? this.props.match.params.userID
      : "";
   // this.props.getUploadTrackingHistory(dealID);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantdealList !== nextProps.merchantdealList) {
      if (nextProps.merchantdealList) {
        isLoading = "false";
        this.setState({ deallist: nextProps.merchantdealList.data });
      }
    }

    if (this.props.uploadHistory !== nextProps.uploadHistory) {
      if (nextProps.uploadHistory) {
        isLoading = "false";
        dealID = this.props.match.params.dealID
          ? this.props.match.params.dealID
          : "";
        this.props.getUploadTrackingHistory(dealID);
        this.setState({ uploadList: nextProps.uploadHistory.data });
      }
    }

    if (this.props.tracknigResponse !== nextProps.tracknigResponse) {
      if (nextProps.tracknigResponse) {
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("success", nextProps.tracknigResponse.message);
        this.setState({ disabled: false });
        this.Clear();
      }
    }

    if (nextProps.message) {
      this.handleShow();
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }

    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        isLoading = "false";
        this.props.clearAlert();
        this.props.renderAlert("warning", nextProps.error);
      }
    }
  }

  Clear() {
    this.state.upload = "";
  }

  render() {
    const { currentPage, totalRecords, perPage, pageCount } = this.state;  

    data = [
            [
              "Voucher Number",
              "Tracking Number",
            ],
            [
              "234445",
              "565555",
            ]
           ];

    let uploadedRow, url;
    let uploadedListData = this.state.uploadList ? this.state.uploadList : "";
    if (!isEmpty(uploadedListData)) {
      uploadedRow = uploadedListData.map((upload, index) => (
        <tr key={upload.trackingUploadedAtEncrypted}>
          <td>
            {upload.merchantName}
          </td>

          <td>
            {" "}
            <a
              href={upload.file}
              target="_blank"
            >
              {" "}
              View{" "}
            </a>{" "}
          </td>
          <td>{upload.trackingUploadedAt}</td>
        </tr>
      ));
    } else {
      uploadedRow = (
        <tr>
          <td>
            {" "}
            <span style={{ color: "red" }}>
              No tracking numbers uploaded!{" "}
            </span>{" "}
          </td>
        </tr>
      );
    }

    return (
      <div className="col-lg-12 add-sub-admin">
        {isLoading == "true" ? (
          <div className="loader">
            <p className="loading-message">
              <i>Loading...</i>
            </p>
            <div className="spinner">
              <div className="dot1" />
              <div className="dot2" />
            </div>
          </div>
        ) : (
          ""
        )}
        <form onSubmit={this.handleSubmit} encType="multipart/form-data">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} />
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">
              {" "}
              Upload Voucher Tracking Numbers
            </header>
            {this.state.show &&
              this.state.alertMessage !== "" && (
                <div className="col-lg-12">
                  <Alert
                    bsStyle={this.state.msgType}
                    onDismiss={this.handleDismiss}
                  >
                    <strong>{this.state.msgType}:</strong>{" "}
                    {this.state.alertMessage}
                  </Alert>
                </div>
              )}

            <div className="panel-body">
              <div className="add-city col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <Row>
                  <Col md={6} xs={12}>
                    <FormGroup controlId="formOffer">
                      <ControlLabel> Upload xls/xlsx File </ControlLabel>
                      <FormControl
                        type="file"
                        value={this.state.upload}
                        placeholder="Notes"
                        onChange={this.handleChange}
                        name="upload"
                        accept=".xlsx, .xls, .csv"
                        //id="uploadfile"
                      />
                    </FormGroup>
                    {this.state.uploadError && (
                      <Tooltip
                        placement="bottom"
                        className="in"
                        id="tooltip-bottom"
                      >
                        {this.state.uploadError}
                      </Tooltip>
                    )}

                    <FormGroup controlId="formdeallist">
                      <CSVLink
                        data={this.state.csvData}
                        filename={"voucherlist.csv"}
                      >
                        Click here
                      </CSVLink>{" "}
                      <ControlLabel>
                        {" "}
                        to download a sample CSV (The CSV should be in this
                        format).
                      </ControlLabel>
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="BtnRow">
                  <Col md={12} xs={12}>
                    <Button
                      bsStyle="info"
                      type="submit"
                      disabled={this.state.disabled}
                    >
                      Upload File{" "}
                    </Button>
                    {userID !== "" ? (
                      <Button
                        bsStyle="default"
                        onClick={() =>
                          this.context.router.history.push(`/trackingnumbers/List/${userID}`)
                        }
                      >
                        Cancel
                      </Button>
                    ) : (
                      <Button
                        bsStyle="default"
                        onClick={() => this.context.router.history.push(`/trackingnumbers/List`)}
                      >
                        Cancel
                      </Button>
                    )}
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </form>

        <div className="panel">
          <header className="panel-heading">
            {" "}
            Tracking File Upload History
          </header>
          <div className="panel-body">
            <div className="row">
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th> User Name </th>
                      <th>Download File </th>
                      <th>Uploaded Date </th>
                    </tr>
                  </thead>
                  <tbody>{uploadedRow}</tbody>
                </table>
                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    merchantdealList: state.voucherReducer.merchantdealList,
    alertType: state.alertsReducer.alertType,
    message: state.alertsReducer.message,
    error: state.voucherReducer.error,
    tracknigResponse: state.voucherReducer.tracknigResponse,
    uploadHistory: state.voucherReducer.uploadHistory
  };
};

export default compose(
  withRouter, // IMPORTANT: witRouter is "needed here" to avoid blocking routing:
  connect(mapStateToProps, {
    getMerchantDeals,
    renderAlert,
    clearAlert,
    getMerchantVoucherList,
    getUploadTrackingHistory,
    upload_TrackingNumbers
  })
)(Upload);



// WEBPACK FOOTER //
// ./src/app/views/merchant/trackingNumbers/Upload.js